(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.crownVideo = {
    attach: function(context, settings) {

      const videoSizeOptions = function(isModal, $btn) {
        var options = {
          width: isModal ? (window.innerWidth * 0.8) : $btn.outerWidth(true),
          height: isModal ? (window.innerHeight * 0.8) : $btn.outerHeight(true)
        };
        return options;
      };

      const onYtPlayerReady = function(event) {
        event.target.playVideo();
      };

      const videoClose = function($media, $btn, player) {
        if (typeof player.pause !== 'undefined') {
          player.pause();
        }
        if (typeof player.pauseVideo !== 'undefined') {
          player.pauseVideo();
        }

        $media.removeClass('video-play');
        $btn.removeAttr('disabled');
      };

      const youTubeEmbed = function($media, $video, $btn, url, isModal = false, i = 0) {
        let player = null;

        if (!window.YT) {
          if (i < 50) {
            let j = i + 1;
            setTimeout(function() {
              return youTubeEmbed($media, $video, $btn, url, isModal, j);
            }, 200);
          }
        }
        else {
          const options = videoSizeOptions(isModal, $btn);
          options.videoId = url.split('/').pop();
          options.splayerVars = {
            'playsinline': 1
          };
          options.events = {
            'onReady': onYtPlayerReady
          };
          player = new window.YT.Player($video[0], options);
          $media.find('.modal-backdrop, .close-video-btn').click(function() {
            videoClose($media, $btn, player);
          });
        }
      };

      const vimeoEmbed = function($media, $video, $btn, url, isModal = false, i = 0) {

        let player = null;
        if (!window.Vimeo) {
          if (i < 50) {
            let j = i + 1;
            setTimeout(function() {
              return vimeoEmbed($media, $video, $btn, url, isModal, j);
            }, 200);
          }
        }
        else {
          const options = videoSizeOptions(isModal, $btn);
          options.url = url;
          // Create the player
          player = new window.Vimeo.Player($video, options);
          // add the video and play
          player.play();
          $btn.attr('disabled', 'disabled');

          $media.find('.modal-backdrop, .close-video-btn').click(function() {
            videoClose($media, $btn, player);
          });
        }
      };

      jQuery('.play-video-btn').once('video-btn-init').each(function() {
        const $playBtn = jQuery(this);
        const $media = $playBtn.closest('article');
        const $video = $media.find('.video');
        const isModal = $media.hasClass('media--view-mode-modal');

        // check cookie compliance, remove notice if the user has agreed
        const cookieAgreed = Drupal.eu_cookie_compliance.getCurrentStatus().toString() === '2'; // 2: agreed, 0: declined
        if (cookieAgreed) {
          $media.find('.iframe-cookie-notice').remove();
        }
        else {
          $media.find('.cookie-settings').click(function() {
            jQuery(' #sliding-popup .agree-button').click(function() {
              // refresh the page so cookies can kick in.
              window.location.reload();
            });
            // move the consent popup into view
            window.showCookieSettings();
          });
        }

        $playBtn.click(function() {
          $media.addClass('video-play');

          const url = $playBtn.attr('data-url');
          if (url.indexOf('vimeo') > 0) {
            vimeoEmbed($media, $video, $playBtn, url, isModal);
          }
          else if (url.indexOf('youtube') > 0 || url.indexOf('youtu.be') > 0) {
            youTubeEmbed($media, $video, $playBtn, url, isModal);
          }
        });
      });
    }
  };

})(jQuery, Drupal);
